<div class="steps-container" *transloco="let t;">
    @for(step of steps(); track step; let index=$index;){
        <div class="step" #stepRef>
            <div class="left-container">
                @if(step.allItems.length > 1 || (step.allItems.length === 1 && !step.selectedOrderableItem()?.isEditable) || step.markedAsDone()){
                    @if(step.isFulfilled){
                        <div class="selected-item-container">
                            <span class="title as-label">{{step.title}}</span>
                            <div class="selected-item-name-container">
                                <div class="check-container">
                                    <cwo-icon size="10px" class="icon" [name]="iconNameType.check" />
                                </div>
                                <cwo-dotted-labels 
                                    [labels]="[step.selectedOrderableItem()?.label ?? step.selectedOrderedItem()?.name ?? '', step.selectedOrderedItem()?.size ?? '']" 
                                    [state]="'inactive'" 
                                    [fontSize]="'var(--font-size-med)'"
                                    [fontWeight]="'var(--font-weight-regular)'" 
                                    [lineHeight]="'1.25rem'" 
                                />
                            </div>
       
                        </div>
                    } @else {
                        <div class="title-container">
                            <span class="title">{{step.title}}</span>
                        </div>
                    }
                } @else {
                    <div class="title-container">
                        <span class="title">{{t('modals.special_item_editor.steps.customize_step',{step: step.selectedOrderableItem()?.label ?? step.selectedOrderableItem()?.name})}}</span>
                    </div>
                }
                @if(!step.isFulfilled){
                    <span class="required" [ngClass]="{error: highlightInvalidFields()}">
                        @if(highlightInvalidFields()){
                            <div class="error-icon">
                                <span>!</span>
                            </div>
                        }
                        {{'Required'}}                
                    </span>
                }
            </div>
            <div class="right-container">
                @if(step.selectedOrderedItem() && step.allItems.length > 1){
                    @if(step.selectedOrderableItem()?.isEditable){
                        <button (click)="editStepItem.emit(index)" class="undecorated-button icon-button"><cwo-icon class="action-icon" size="1.5rem" [name]="iconNameType.edit" /></button>
                    }
                    @if(step.selectedOrderableItem()?.isEditable && step.allItems.length > 1){
                        <div class="divider"></div>
                    }
                    <button class="undecorated-button icon-button" (click)="handleShuffle(index)"><cwo-icon class="action-icon" size="1.5rem" [name]="iconNameType.shuffle" /></button>                    
                } @else if (!step.selectedOrderedItem() || step.selectedOrderableItem()?.isEditable) {
                    <div class="undercorated-button arrow">
                        <cwo-icon class="arrow-icon" size="1rem" [name]="iconNameType.arrow" />
                    </div>
                    <button class="button-undecorated full-container-absolute-button"  (click)="step.allItems.length === 1 ? editStepItem.emit(index) : handleShuffle(index)">
                        {{t('modals.special_item_editor.steps.edit_step',{step: step.title})}}
                    </button>
                }
            </div>
        </div>
    }
</div>
